import React from "react";

const ToggleButtonWithText = ({
  isToggle,
  handleLeftButtonClick,
  handleRightButtonClick,
  leftButtonLabel = "Button 1",
  rightButtonLabel = "Button 2",
  className,
  isDisabled = false,
}) => {
  return (
    <div className={`price-change-toggle-button-wrapper ${className}`}>
      <button
        type="button"
        className={`price-change-toggle-button ${
          !isToggle && "price-change-active-button"
        } ${isDisabled && "disabled-icon"}`}
        onClick={() => handleLeftButtonClick()}
        disabled={isDisabled}
      >
        {leftButtonLabel}
      </button>
      <button
        type="button"
        className={`price-change-toggle-button ${
          isToggle && "price-change-active-button"
        } ${isDisabled && "disabled-icon"}`}
        onClick={() => handleRightButtonClick()}
        disabled={isDisabled}
      >
        {rightButtonLabel}
      </button>
      <div
        className={`price-change-toggle-button-background  ${
          isToggle && "by-price-change-active"
        }`}
      ></div>
    </div>
  );
};

export default ToggleButtonWithText;
